export default class AzureSearchServiceConstants {
  static readonly AzureSearchService = 'Azure Search Service';
  static readonly AzureSearchServicePermissionWarn =
    'You do not have permission to view AzureSearchService.';
  static readonly AzureSearchServiceDeleteWarn =
    'Are you sure you want to delete the Azure Search Service?';
  static readonly AzureSearchServiceDeleteSuc =
    'Azure Search Service Entry Deleted Successfuly !';
  static readonly AzureSearchServiceSaveSuc =
    'Azure Search Service Saved Successfuly !';
  static readonly AzureSearchServiceSaveFailed =
    'failed to load Azure Search Service details';
  static readonly AzureSearchServiceChangeWarn =
    ' Are you sure you want to make this change?';
}
